import { useMemo } from "react";

import { ChartFocusFeature } from "types";

import useColumns, { useFacilityColumns } from "hooks/useColumns";
import useUserUnit from "hooks/useUserUnit";

import { EntityKind } from "models/entityKind";

export function useChartFocusUnitCorrection(
  chartFocusRaw: Partial<ChartFocusFeature> | undefined
): Partial<ChartFocusFeature> | undefined {
  const wellColumns = useColumns();
  const facilityColumns = useFacilityColumns();
  const unitType = useUserUnit();

  return useMemo(() => {
    if (!chartFocusRaw?.properties?.groupBy) return chartFocusRaw;

    const groupBy = chartFocusRaw.properties.groupBy;
    const { title, property, entityKind } = groupBy;

    if (!title || !property) return chartFocusRaw;

    const columns = entityKind === EntityKind.Facility ? facilityColumns : wellColumns;
    const column = columns.find((col) => col.property === property);

    if (!column?.units) return chartFocusRaw;

    const correctUnit = column.units[unitType];
    if (!correctUnit) return chartFocusRaw;

    let correctedTitle = title;
    if (title.includes("(") && title.includes(")")) {
      correctedTitle = title.replace(/\([^)]*\)/, `(${correctUnit})`);
    }

    if (correctedTitle === title) return chartFocusRaw;

    return {
      ...chartFocusRaw,
      properties: {
        ...chartFocusRaw.properties,
        groupBy: {
          ...groupBy,
          title: correctedTitle
        }
      }
    };
  }, [chartFocusRaw, wellColumns, facilityColumns, unitType]);
}

export default useChartFocusUnitCorrection;
